import {t} from 'ttag';

export const attachmentTypeLabels = (): Record<
    ValidAttachmentType,
    string
> => ({
    acceptance: t`Acceptance Certificate`,
    deliveryslip: t`Delivery Slip`,
    invoice: t`Invoice`,
    order: t`Order`,
    orderconfirmation: t`Order Confirmation`,
    orderslip: t`Order Slip`,
    paymentnotice: t`Payment Notice`,
    pdf: t`PDF`,
    quote: t`Quote`,
    receipt: t`Receipt`,
    timesheet: t`Timesheet`,
    zip: t`ZIP`,
});

export type ValidAttachmentType =
    | 'acceptance'
    | 'deliveryslip'
    | 'invoice'
    | 'order'
    | 'orderconfirmation'
    | 'orderslip'
    | 'paymentnotice'
    | 'pdf'
    | 'quote'
    | 'receipt'
    | 'timesheet'
    | 'zip';
